/**
 * Resolve a picker item's canonical WhatsApp JID for selection / adding to an
 * audience. Shared by the contact/recipient pickers.
 */
export const getContactSerializedId = (contact: any): string | undefined =>
    // BE#272: LEAN cache items (post #63/#64) carry the JID only on `chatId`
    // (and on `_id`, which the backend merge sets to the JID). Without these
    // fallbacks a lean group resolved to undefined and could not be added.
    contact?.id?._serialized || contact?.waId || contact?._serialized || contact?.whatsappId ||
    contact?.chatId || contact?._id;
